/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CheckWizardAssignmentConflictsRequestDto,
  CreatePlanFromWizardRequestDto,
  CreatePlanRequestDto,
  ListAssignableAssetIdsResponseDto,
  ListAssignableAssetsResponseDto,
  ListAssignmentConflictsResponseDto,
  ListPlansResponseDto,
  ListWizardFilterOptionsResponseDto,
  PlanResponseDto,
  PreviewPlanFromWizardRequestDto,
  PreviewPlanFromWizardResponseDto,
  UpdatePlanRequestDto,
} from '../models/index';
import {
    CheckWizardAssignmentConflictsRequestDtoFromJSON,
    CheckWizardAssignmentConflictsRequestDtoToJSON,
    CreatePlanFromWizardRequestDtoFromJSON,
    CreatePlanFromWizardRequestDtoToJSON,
    CreatePlanRequestDtoFromJSON,
    CreatePlanRequestDtoToJSON,
    ListAssignableAssetIdsResponseDtoFromJSON,
    ListAssignableAssetIdsResponseDtoToJSON,
    ListAssignableAssetsResponseDtoFromJSON,
    ListAssignableAssetsResponseDtoToJSON,
    ListAssignmentConflictsResponseDtoFromJSON,
    ListAssignmentConflictsResponseDtoToJSON,
    ListPlansResponseDtoFromJSON,
    ListPlansResponseDtoToJSON,
    ListWizardFilterOptionsResponseDtoFromJSON,
    ListWizardFilterOptionsResponseDtoToJSON,
    PlanResponseDtoFromJSON,
    PlanResponseDtoToJSON,
    PreviewPlanFromWizardRequestDtoFromJSON,
    PreviewPlanFromWizardRequestDtoToJSON,
    PreviewPlanFromWizardResponseDtoFromJSON,
    PreviewPlanFromWizardResponseDtoToJSON,
    UpdatePlanRequestDtoFromJSON,
    UpdatePlanRequestDtoToJSON,
} from '../models/index';

export interface PlanControllerCheckWizardConflictsRequest {
    checkWizardAssignmentConflictsRequestDto: CheckWizardAssignmentConflictsRequestDto;
}

export interface PlanControllerCreateRequest {
    createPlanRequestDto: CreatePlanRequestDto;
}

export interface PlanControllerCreateFromWizardRequest {
    createPlanFromWizardRequestDto: CreatePlanFromWizardRequestDto;
}

export interface PlanControllerFindByIdRequest {
    id: string;
}

export interface PlanControllerPreviewFromWizardRequest {
    previewPlanFromWizardRequestDto: PreviewPlanFromWizardRequestDto;
}

export interface PlanControllerUpdateRequest {
    id: string;
    updatePlanRequestDto: UpdatePlanRequestDto;
}

/**
 * 
 */
export class PreventiveMaintenancePlansApi extends runtime.BaseAPI {

    /**
     */
    async planControllerCheckWizardConflictsRaw(requestParameters: PlanControllerCheckWizardConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignmentConflictsResponseDto>> {
        if (requestParameters['checkWizardAssignmentConflictsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'checkWizardAssignmentConflictsRequestDto',
                'Required parameter "checkWizardAssignmentConflictsRequestDto" was null or undefined when calling planControllerCheckWizardConflicts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard/check-conflicts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckWizardAssignmentConflictsRequestDtoToJSON(requestParameters['checkWizardAssignmentConflictsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignmentConflictsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerCheckWizardConflicts(requestParameters: PlanControllerCheckWizardConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignmentConflictsResponseDto> {
        const response = await this.planControllerCheckWizardConflictsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerCreateRaw(requestParameters: PlanControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanResponseDto>> {
        if (requestParameters['createPlanRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createPlanRequestDto',
                'Required parameter "createPlanRequestDto" was null or undefined when calling planControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePlanRequestDtoToJSON(requestParameters['createPlanRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerCreate(requestParameters: PlanControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanResponseDto> {
        const response = await this.planControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerCreateFromWizardRaw(requestParameters: PlanControllerCreateFromWizardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanResponseDto>> {
        if (requestParameters['createPlanFromWizardRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createPlanFromWizardRequestDto',
                'Required parameter "createPlanFromWizardRequestDto" was null or undefined when calling planControllerCreateFromWizard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePlanFromWizardRequestDtoToJSON(requestParameters['createPlanFromWizardRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerCreateFromWizard(requestParameters: PlanControllerCreateFromWizardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanResponseDto> {
        const response = await this.planControllerCreateFromWizardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPlansResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPlansResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPlansResponseDto> {
        const response = await this.planControllerFindAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerFindByIdRaw(requestParameters: PlanControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling planControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerFindById(requestParameters: PlanControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanResponseDto> {
        const response = await this.planControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerFindWizardAssignableAssetIdsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignableAssetIdsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard/assignable-assets/ids`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignableAssetIdsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerFindWizardAssignableAssetIds(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignableAssetIdsResponseDto> {
        const response = await this.planControllerFindWizardAssignableAssetIdsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerFindWizardAssignableAssetsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignableAssetsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard/assignable-assets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignableAssetsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerFindWizardAssignableAssets(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignableAssetsResponseDto> {
        const response = await this.planControllerFindWizardAssignableAssetsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerFindWizardFilterAssetModelsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWizardFilterOptionsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard/filter-options/asset-models`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWizardFilterOptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerFindWizardFilterAssetModels(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWizardFilterOptionsResponseDto> {
        const response = await this.planControllerFindWizardFilterAssetModelsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerFindWizardFilterAssetTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWizardFilterOptionsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard/filter-options/asset-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWizardFilterOptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerFindWizardFilterAssetTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWizardFilterOptionsResponseDto> {
        const response = await this.planControllerFindWizardFilterAssetTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerFindWizardFilterLandlordsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWizardFilterOptionsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard/filter-options/landlords`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWizardFilterOptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerFindWizardFilterLandlords(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWizardFilterOptionsResponseDto> {
        const response = await this.planControllerFindWizardFilterLandlordsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerFindWizardFilterSitesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWizardFilterOptionsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard/filter-options/sites`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWizardFilterOptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerFindWizardFilterSites(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWizardFilterOptionsResponseDto> {
        const response = await this.planControllerFindWizardFilterSitesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerPreviewFromWizardRaw(requestParameters: PlanControllerPreviewFromWizardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreviewPlanFromWizardResponseDto>> {
        if (requestParameters['previewPlanFromWizardRequestDto'] == null) {
            throw new runtime.RequiredError(
                'previewPlanFromWizardRequestDto',
                'Required parameter "previewPlanFromWizardRequestDto" was null or undefined when calling planControllerPreviewFromWizard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/wizard/preview`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreviewPlanFromWizardRequestDtoToJSON(requestParameters['previewPlanFromWizardRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreviewPlanFromWizardResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerPreviewFromWizard(requestParameters: PlanControllerPreviewFromWizardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreviewPlanFromWizardResponseDto> {
        const response = await this.planControllerPreviewFromWizardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planControllerUpdateRaw(requestParameters: PlanControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling planControllerUpdate().'
            );
        }

        if (requestParameters['updatePlanRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updatePlanRequestDto',
                'Required parameter "updatePlanRequestDto" was null or undefined when calling planControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePlanRequestDtoToJSON(requestParameters['updatePlanRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planControllerUpdate(requestParameters: PlanControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanResponseDto> {
        const response = await this.planControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
